import request from '@/utils/request'

export function fetchPaymentRateTemplateList(params) {
  return request({
    url: '/mchChannel/payment/plans',
    method: 'get',
    params
  })
}

export function fetchPayoutRateTemplateList(params) {
  return request({
    url: '/mchChannel/payout/plans',
    method: 'get',
    params
  })
}

export function sendSecrtKeySms(data) {
  return request({
    url: '/mchApp/sendSms',
    method: 'post',
    data
  })
}

export function sendSecrtKeyEmail(data) {
  return request({
    url: '/mchApp/sendEmail',
    method: 'post',
    data
  })
}
